import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Config from '@skin_config';

import { Swarm } from '@lbs/swarm-client';

import { UserProfileUpdateReceived } from '@app/dev/actions/user';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import Helpers from '@common/helpers/helperFunctions';
import { store } from '@app/dev/index/terminalApp';
import { LoadCurrencyConfig } from '@app/dev/actions/initialData';
import { todoImplementErrorHandling } from '@common/helpers';

const query = {
  source: 'user',
  what: { profile: [] },
};

const ProfileHandler = () => {
  const subId = useRef();
  const dispatch = useDispatch();

  const loadCurrencyConfig = (profile) => {
    if (!profile?.currency_id || store.getState().swarmConfigData.currency?.[profile.currency_id]) {
      return null;
    }

    return dispatch(LoadCurrencyConfig(profile.currency));
  };

  const loadProfile = async () => {
    try {
      const result = await Swarm.getInstance().subscribe(
        query,
        (data) => {
          dispatch(UserProfileUpdateReceived(Helpers.firstElement(data?.profile)));
        },
        true,
      );

      subId.current = result.subid;

      const profile = Helpers.firstElement(result.data?.profile);
      if (Config.main.loadUserCurrencyConfig) loadCurrencyConfig(profile);
      dispatch(UserProfileUpdateReceived(profile));
    } catch {
      todoImplementErrorHandling();
    }
  };

  useEffect(() => {
    loadProfile();
    return () => {
      Swarm.getInstance()
        .unsubscribe(subId.current)
        .catch((ex) => { }); // after logout call there is no need to unsubscribe from profile (swarm part), but we need to make unsubscribe call to remove subId from our swarm
    };
  });

  return null;
};
export default asyncWrapper(React.memo(ProfileHandler));
